import React from 'react';
import styles from './styles.module.scss';
import { compose } from 'redux';
import withRouter from 'src/shared/utils/withRouter';
import LayoutWrapper from 'src/shared/components/LayoutWrapper';
import Section from 'src/shared/components/Section';
import UserType from 'src/shared/config/UserType';
import RoutePaths from 'src/config/RoutePaths';
import globalActions from 'src/shared/store/global/actions';
import Message from 'src/shared/config/Message';
import Language from 'src/config/Language';
import ReviewProfile from 'src/shared/components/ReviewProfile';
import withNoAuth from 'src/shared/utils/withNoAuth';
import AccountAPI from 'src/shared/services/api/AccountAPI';
import { withTranslation } from 'next-i18next';
import ServerAPI from 'src/services/api/ServerAPI';
import common from 'src/shared/utils/common';
import GaService from 'src/services/GaService';
import GaCategory from 'src/config/GaCategory';
import GaAction from 'src/config/GaAction';
import MetaData from 'src/config/MetaData';

import RegistrationForm from './components/RegistrationForm';
import HjEvent from 'src/config/HjEvent';

class Register extends React.Component {
    constructor(props) {
        super(props);

        this.userType = Object.keys(UserType).map((key) => ({ label: this.props.t('register_' + UserType[key]), value: UserType[key] }));
        this.state = {
            step: 1,
            formType: undefined,
            result: null,
        };

        this.headerProps = { type: 'transparent', fixed: true };
        this.prevQueryFormTyp = null;
    }

    componentDidMount() {
        this.checkFormType();
    }

    componentDidUpdate() {
        const { router } = this.props;
        const doesQueryFormTypeChange = this.prevQueryFormType === router.query.t;

        if (!doesQueryFormTypeChange) {
            this.prevQueryFormType = router.query.t;
            this.checkFormType();
        }
    }

    checkFormType = () => {
        const { router } = this.props;
        if (!router.isReady) {
            return;
        }
        this.setState({
            formType: router.query.t === UserType.ADVISOR ? UserType.ADVISOR : UserType.INVESTOR,
        });
    };

    register = async (data) => {
        const { router } = this.props;
        const { formType } = this.state;
        const { dispatch, t } = this.props;

        if (formType === UserType.INVESTOR) {
            GaService.callEvent(GaCategory.register, GaAction.clickCreateAccountButtonForInvestor, '');
        } else {
            GaService.callEvent(GaCategory.register, GaAction.clickCreateAccountButtonForAdvisor);
        }
        if (window.hj) {
            window.hj('event', [HjEvent.clickConfirmCreateAccountButton]);
        }
        data.type = formType.toLowerCase();
        data.preferredLocale = Language[router.locale].locale;
        const serverTime = await ServerAPI.getServerTime();
        common.setMomentOffset(serverTime);
        const resp = await AccountAPI.register(data, this.props.router.query);
        await dispatch(globalActions.dismissModal());
        if (!resp.status) {
            dispatch(
                globalActions.showConfirmDialog({
                    text: resp.message || t(Message.NETWORK_ERROR),
                })
            );
            GaService.callEvent(GaCategory.register, GaAction.registerFailed, resp.message);
            if (window.hj) {
                window.hj('event', [HjEvent.registerFailed]);
            }
            return false;
        }

        GaService.callEvent(GaCategory.register, GaAction.registerSuccess);
        if (window.hj) {
            window.hj('event', [HjEvent.registerSuccess]);
        }
        this.setState({ result: resp });
        return true;
    };

    onStepChange = (step) => this.setState({ step });

    onFormTypeChange = (formType) => {
        const { router } = this.props;

        if (formType === 'advisor') {
            router.pushPath(RoutePaths.REGISTER, { t: 'advisor' }, { shallow: true });
        } else {
            router.pushPath(RoutePaths.REGISTER, {}, { shallow: true });
        }
    };

    renderForm = () => {
        const { formType, step } = this.state;

        if (!formType) {
            return null;
        }

        const isInvestor = formType === UserType.INVESTOR;

        return (
            <Section
                sectionClassName={styles.sectionContainer}
                className={styles.headSection}
                fullWidth
                containerStyle={{
                    padding: 0,
                    backgroundColor: '#09111B',
                    backgroundImage:
                        formType === UserType.INVESTOR
                            ? "url('/static/images/Register-Investor(BG)@2x.jpg')"
                            : "url('/static/images/Register-Advisor(BG)@2x.jpg')",
                }}
            >
                <RegistrationForm
                    step={step}
                    isInvestor={isInvestor}
                    onStepChange={this.onStepChange}
                    onRegister={this.register}
                    onFormTypeChange={this.onFormTypeChange}
                />
            </Section>
        );
    };

    renderResult = () => {
        const { formType } = this.state;
        return (
            <Section
                withFixedHeader
                containerStyle={{
                    backgroundImage:
                        formType === UserType.INVESTOR
                            ? "url('/static/images/Register-Investor(BG)@2x.jpg')"
                            : "url('/static/images/Register-Advisor(BG)@2x.jpg')",
                }}
            >
                <ReviewProfile />
            </Section>
        );
    };

    render() {
        const { result } = this.state;

        return (
            <LayoutWrapper className={styles.container} headerProps={this.headerProps} metaProps={MetaData[RoutePaths.REGISTER]}>
                {!result ? this.renderForm() : this.renderResult()}
            </LayoutWrapper>
        );
    }
}

export default compose(withTranslation(), withNoAuth({ isPage: true }), withRouter)(Register);
